import { UploadCloud } from "lucide-react";
import { api } from "../lib/api";

export default function ResumeUploadBox({ onParsed, loading, setLoading, setError, testId }) {
  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    setError("");
    try {
      const response = await api.parseResume(formData);
      onParsed(response.data.text, { ...response.data, originalFile: file });
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to read this resume file. Please upload PDF, DOCX, or TXT.");
    } finally {
      setLoading(false);
      event.target.value = "";
    }
  };

  return (
    <label className="grid cursor-pointer gap-3 border border-dashed border-[#94A3B8] bg-white p-4 transition-colors hover:border-[#0066FF]" data-testid={`${testId}-upload-field`}>
      <span className="flex items-center gap-2 text-sm font-black text-[#0A2540]" data-testid={`${testId}-upload-label`}>
        <UploadCloud className="h-5 w-5 text-[#0066FF]" /> Upload resume file
      </span>
      <span className="text-xs font-semibold leading-5 text-[#64748B]" data-testid={`${testId}-upload-help-text`}>PDF, DOCX, or TXT. Visual formatting like borders stays in your original file.</span>
      <input type="file" accept=".pdf,.docx,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain" onChange={handleFile} disabled={loading} className="text-sm text-[#475569] file:mr-4 file:border-0 file:bg-[#0A2540] file:px-4 file:py-2 file:text-sm file:font-bold file:text-white" data-testid={`${testId}-upload-input`} />
    </label>
  );
}